<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-infinity"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="processDetail.arrangement"
                    filled
                    label="Số thứ tự "
                    placeholder="Nhập số thứ tự"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="processDetail.name"
                    filled
                    label="Name"
                    placeholder="Enter name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Description</div>
                <ck-content class="ck-content" :content="processDetail.description"
                            @getData="value => processDetail.description = value"></ck-content>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="processDetail.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Mô tả</div>
                <ck-content class="ck-content" :content="processDetail.description_vi"
                            @getData="value => processDetail.description_vi = value"></ck-content>
              </v-col>
            </v-col>
          </v-row>
          <v-col cols="12" class="text-center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {GET_DETAIL_PROCESS, UPDATE_PROCESS} from "@/store/modules/process";
import {mapGetters} from "vuex";
import CkContent from "@/components/ck-content";


export default {
  name: "Edit_process",
  components: {
    CkContent,
  },
  data() {
    return {
      page: "Sửa process",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách process",
          disabled: true,
        },
        {
          text: "Sửa process",
          disabled: false,
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      processDetail: "processDetail"
    })
  },
  async created() {
    await this.$store.dispatch(GET_DETAIL_PROCESS, this.$route.params.id);
  },
  methods: {
    async save() {
      await this.$store.dispatch(`${UPDATE_PROCESS}`, this.processDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/process')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>